import * as React from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import logo from './images/bee-dialog-thumb.png';

export default class NavMenu extends React.PureComponent<{}, { isOpen: boolean }> {
    public state = {
        isOpen: false
    };

    public render() {
        return (
            <header>
                <Navbar className="fixed-top dark navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3" color="light" light>
                    <Container>
                        <Link to="/buzz" className="navbar-brand-link"><img src={logo} alt="hearder logo thumbnail" className="navbar-brand-logo" />&nbsp;<span className="navbar-brand-text">BeeBee.social</span></Link>
                        {/* <Link to="/buzz" className="navbar-brand-text">BeeBee.social</Link> */}
                        {/* <NavbarBrand tag={Link} to="/buzz" className="navbar-brand-text">BeeBee.social</NavbarBrand> */ }
                        {/* <NavbarToggler onClick={this.toggle} className="mr-2"/> */}
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/blog">Blog</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/help">Help</NavLink>
                                </NavItem>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
}
